<!-- 关联企业 -->
<template>
  <div class="relation">
    <div class="relation-title">
      <span class="relation-title-t">合作企业</span>
      <span class="relation-title-b">让顾客更直观的去了解网站上所展示的产品</span>
    </div>
    <div class="relation-main">
      <div class="relation-img" v-for="(item,index) of list" :key="index">
        <div :style="'background-image:url(' + item + ')'"></div>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from '@/assets/img/icon-home/state-grid_01.png'
import img2 from '@/assets/img/icon-home/state-grid_03.png'
import img3 from '@/assets/img/icon-home/state-grid_07.png'
import img4 from '@/assets/img/icon-home/state-grid_08.png'
import img5 from '@/assets/img/icon-home/state-grid_11.png'
import img6 from '@/assets/img/icon-home/state-grid_12.png'
import img7 from '@/assets/img/icon-home/state-grid_17.png'
import img8 from '@/assets/img/icon-home/state-grid_15.png'
import img9 from '@/assets/img/icon-home/state-grid_19.png'
import img10 from '@/assets/img/icon-home/state-grid_02.png'
export default {
  data () {
    return {
      list: [img5, img4, img2, img9, img10, img6, img7, img8, img3, img1]
    }
  }
}
</script>
<style lang="scss" scoped>
.relation {
  width: 100%;
  background-color: #f2f2f2;
  border-top: 1px solid #ffffff;
  display: flex;
  flex-direction: column;
  .relation-title {
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .relation-title-t {
      padding: 8px 0;
      font-size: 18px;
      color: #222222;

      font-weight: 700;
    }
    .relation-title-b {
      padding: 8px 0;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
  .relation-main {
    width: 100%;
    margin: 0 auto;
    padding: 0 40px 40px 40px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-row-gap: 20px;
    .relation-img {
      padding: 20px 0;
      width: 100%;
      height: 100px;
      box-sizing: border-box;
      text-align: center;
      overflow: auto;
      div {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/relation/relation.vue